<script>
  //// imports
  import Button from "./Button.svelte";
  import AssistantChevrons from "./assistant/assistantChevrons.svelte";

  //// vars
  export let total = 42;
  export let currentpage = 1;
  export let itemsPerPage = 5;
  export let disablePrev = false;
  export let disableNext = false;
  export let size = "md";

  function handlePrev() {
    if (currentpage > 1) {
      currentpage--;
    }
  }

  function handleNext() {
    if (currentpage < total / itemsPerPage) {
      currentpage++;
    }
  }

  $$restProps;
</script>

<div class="pagination_wrapper" class:sm={size === "sm"}>
  <AssistantChevrons
    expand={true}
    disabled={disablePrev}
    on:buttonClicked={handlePrev}
  />

  <div class="pagination">
    <span class="bold"
      >{(currentpage - 1) * itemsPerPage + 1} - {Math.min(
        currentpage * itemsPerPage,
        total
      )}</span
    >
    of
    <span class="bold">{total}</span>
    <!-- @Adrian habe ich ausgeblendet, da diese Info eh wegen dem Heading redundant ist
    und oft das Layout zerschießt -->
    <!-- {item} -->
  </div>

  <AssistantChevrons
    expand={true}
    flip={true}
    disabled={disableNext}
    on:buttonClicked={handleNext}
  />
</div>

<style>
  .pagination_wrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
  }

  .pagination {
    display: flex;
    flex-grow: 1;
    gap: 0.5rem;
    background-color: var(--pax-smoke);
    border-radius: 0.5rem;
    color: var(--pax-black);
    align-items: center;
    justify-content: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .sm .pagination {
    height: 2.5rem;
  }

  .sm :global(.chevron_wrapper) {
    height: 2.5rem;
    width: 2.5rem;
  }
</style>
